// What a {RecId;n} slot of a document report means, from the column the SQL
// compares it with (auth fetchReports → recid_fields). Known columns get a
// readable label; anything else shows the column name with its slot number.

const LABELS = {
    docnr:          { nl: 'Documentnummer',    fr: 'Numéro de document',      en: 'Document number' },
    coid:           { nl: 'Firma',             fr: 'Société',                 en: 'Company' },
    corp:           { nl: 'Firma',             fr: 'Société',                 en: 'Company' },
    ticketnr:       { nl: 'Ticketnummer',      fr: 'Numéro de ticket',        en: 'Ticket number' },
    klnr:           { nl: 'Klantnummer',       fr: 'Numéro de client',        en: 'Customer number' },
    barcode:        { nl: 'Barcode',           fr: 'Code-barres',             en: 'Barcode' },
    barbody:        { nl: 'Artikel (barbody)', fr: 'Article (barbody)',       en: 'Article (barbody)' },
    kleurnr:        { nl: 'Kleurnummer',       fr: 'Numéro de couleur',       en: 'Colour number' },
    levnr:          { nl: 'Leverancier',       fr: 'Fournisseur',             en: 'Supplier' },
    transfernr:     { nl: 'Transfernummer',    fr: 'Numéro de transfert',     en: 'Transfer number' },
    transferid:     { nl: 'Transfernummer',    fr: 'Numéro de transfert',     en: 'Transfer number' },
    bestelnr:       { nl: 'Bestelnummer',      fr: 'Numéro de commande',      en: 'Order number' },
    orderno:        { nl: 'Bestelnummer',      fr: 'Numéro de commande',      en: 'Order number' },
    bbonnr:         { nl: 'Bestelbonnummer',   fr: 'Numéro de bon de commande', en: 'Purchase order number' },
    reservatie:     { nl: 'Reservatienummer',  fr: 'Numéro de réservation',   en: 'Reservation number' },
    reservatienr:   { nl: 'Reservatienummer',  fr: 'Numéro de réservation',   en: 'Reservation number' },
    reservation_id: { nl: 'Reservatienummer',  fr: 'Numéro de réservation',   en: 'Reservation number' },
    listno:         { nl: 'Lijstnummer',       fr: 'Numéro de liste',         en: 'List number' },
    returnid:       { nl: 'Retournummer',      fr: 'Numéro de retour',        en: 'Return number' },
    recno:          { nl: 'Recordnummer',      fr: "Numéro d'enregistrement", en: 'Record number' },
    message_number: { nl: 'Berichtnummer',     fr: 'Numéro de message',       en: 'Message number' },
    fileid:         { nl: 'Bestands-id',       fr: 'ID de fichier',           en: 'File id' },
    mag:            { nl: 'Winkel',            fr: 'Magasin',                 en: 'Store' },
    kassa:          { nl: 'Kassa',             fr: 'Caisse',                  en: 'Register' },
};

const pickLang = (entry, lang) => entry[lang] || entry.nl || entry.en;

/** The field info for one slot: { index, column, table } (column may be ''). */
export const recIdField = (report, slot) => {
    const fields = Array.isArray(report?.recid_fields) ? report.recid_fields : [];
    return fields.find((f) => Number(f.index) === Number(slot)) || { index: slot, column: '', table: '' };
};

/** Human label for slot n of this report, e.g. "Documentnummer" / "Firma". */
export const recIdLabel = (report, slot, lang) => {
    const field = recIdField(report, slot);
    const column = String(field.column || '').toLowerCase();
    const table = String(field.table || '').toLowerCase();
    if (LABELS[column]) return pickLang(LABELS[column], lang);
    if (column === 'code' && table === 'magazijn') return pickLang(LABELS.mag, lang);
    if (column === 'code' && table === 'kassa') return pickLang(LABELS.kassa, lang);
    return column ? `${column} (RecId ${slot})` : `RecId ${slot}`;
};

/**
 * Which pick list fits slot n: 'corps' (coid), 'stores' (magazijn), or
 * 'registers' (kassa); null = free text (comma list).
 */
export const recIdLookupKind = (report, slot) => {
    const field = recIdField(report, slot);
    const column = String(field.column || '').toLowerCase();
    const table = String(field.table || '').toLowerCase();
    if (column === 'coid' || column === 'corp') return 'corps';
    if (column === 'mag' || (column === 'code' && table === 'magazijn')) return 'stores';
    if (column === 'kassa' || column === 'kassaid' || (column === 'code' && table === 'kassa')) return 'registers';
    return null;
};
